module.exports = __webpack_public_path__ + "static/media/55B13BEF-637B-41F8-B34C-8E39D48FD97E.f073cfb9.JPG";